import type { UIMessage } from 'ai'

import { debounceFilter } from '@vueuse/core'

export const useFindingAssistantChatHistory = () => {
  const getChatKey = (workspaceId: string) => `${workspaceId}::finding-assistant::chat`

  const { activeWorkspaceId } = useAuth()
  const storedChat = useSessionStorage<{
    chatId: string
    messages: UIMessage[]
  }>(getChatKey(activeWorkspaceId.value ?? ''), {
    chatId: crypto.randomUUID(),
    messages: [],
  }, { flush: 'sync', eventFilter: debounceFilter(100) })

  const messages = computed(() => storedChat.value?.messages ?? [])
  const chatId = computed(() => storedChat.value?.chatId)

  const store = (chatId: string, messages: UIMessage[]) => {
    storedChat.value = {
      chatId,
      messages,
    }
  }

  watch(activeWorkspaceId, (newId, oldId) => {
    if (newId !== oldId && oldId)
      sessionStorage.removeItem(getChatKey(oldId ?? ''))
  })

  return {
    messages,
    chatId,
    store,
    getChatKey: () => getChatKey(activeWorkspaceId.value ?? ''),
  }
}
